import { Component } from 'react';
import Loading from '../../../components/Loading';
import { getSortKeys, setAdditionalStyles } from '../../../helpers/table';
import { COLUMNS } from './keys';
import DataTable from '../../../components/Datatable';
import AdditionalBox from './additionalBox';
import { withTranslation } from 'react-i18next';
import CompetitiorsModal from './modal/competitors';

class AiTrackingProjects extends Component {
    constructor() {
        super();
        this.updateData = this.updateData.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        this.state = {
            loadingKeywords: false,
            isOpen: false,
            competitiors: [],
        };
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.name?.toLowerCase().includes(search.toLowerCase()));
    }

    onOpenModal(items) {
        this.setState({
            isOpen: true,
            competitiors: items,
        });
    }

    onCloseModal() {
        this.setState({
            isOpen: false,
        });
    }

    updateData(type, id, data) {
        let projects = [];
        if (type === 'delete') {
            projects = this.props?.projects?.filter((item) => item.id !== id);
        } else {
            projects = this.props?.projects?.map((item) => {
                if (item.id === id) {
                    return {
                        ...item,
                        ...data,
                    };
                }
                return item;
            });
        }
        this.props.setProjects(projects);
    }

    render() {
        const { t } = this.props;

        const additionalBox = () => (
            <AdditionalBox t={t} getProjectsData={this.props.getProjectsData} />
        );
        return (
            <>
                <div className="card table-main rounded-main ">
                    <div>
                        {this.props.loading && <Loading padding={10} />}
                        {!this.props.loading && (
                            <DataTable
                                nodes={this.props.projects ?? []}
                                sortFns={getSortKeys(COLUMNS(t))}
                                searchFunction={this.searchFunction}
                                COLUMNS={COLUMNS(t, this.updateData, this.onOpenModal)}
                                additionalBox={additionalBox}
                                customEmptyMessage={t('global.no_data')}
                                additionalStyles={setAdditionalStyles(COLUMNS(t))}
                            />
                        )}
                    </div>{' '}
                </div>
                <CompetitiorsModal
                    competitiors={this.state.competitiors}
                    isOpen={this.state.isOpen}
                    onClose={this.onCloseModal}
                />
            </>
        );
    }
}

export default withTranslation()(AiTrackingProjects);
